<template>
    <div class="container">

        <div class="mt-5 mb-2 fl-te-c card">
            <btn text="<-" class="" @click="$router.go(-1)" size="sm"/>
            <h4 class="text-primary mb-0 font-poppins-semibold">INTERVIEW SUB TOPIC</h4>

            <div>
                <btn size="sm" text="ADD" icon="fa fa-plus"
                     @click="$refs.addInterviewSubTopic.show();"></btn>
            </div>
        </div>
        <div class="card mt-2">
            <div class="row m-0">
                <div class="col-12">
                    <vue-table ref="table" :fields="fields" :url="listURL" :per-page="50">
                        <template slot="actions" slot-scope="props">
                            <div class="btn-group">
                                <btn text="" size="sm" icon="fa fa-pencil" color="primary"
                                     @click="editItem(props.rowData)"/>
                                <btn text="" size="sm" icon="fa fa-trash" color="danger"
                                     @click="deleteItem(props.rowData.id)"/>
                            </div>

                        </template>
                    </vue-table>

                </div>

            </div>
        </div>

        <modal ref="addInterviewSubTopic" :no-close-on-backdrop="true" width="40r" header-color="primary"  title="Interview Topic" :show-additional-buttons="true">
            <template #buttons>
                <a @click="addClose"><i class="fa fa-close"></i></a>
            </template>
            <s-form @submit="addEditItem">
                <div class="row">
                     <div class="col-lg-12">
                        <validated-ajax-vue-select :url="topicSelectUrl" label="Topic" v-model="model.topic"></validated-ajax-vue-select>

                    </div>
                    <div class="col-lg-12">
                        <validated-input label="Name" :rules="{required: true}"
                                         class="" border-radius="1" v-model="model.name "></validated-input>
                    </div>
                    <div class="col-lg-12">
                        <validated-text-area label="Custom Prompt"
                                         class="" border-radius="1" v-model="model.custom_prompt "></validated-text-area>
                    </div>
                    <div class="col-12 text-right mt-4">
                        <btn text="Save" :loading="addLoading" loading-text="Saving..." class="px-4"></btn>
                    </div>
                </div>
            </s-form>
        </modal>
        <modal ref="editInterviewSubTopic" :no-close-on-backdrop="true" width="40r" header-color="primary"  title="Interview Topic">
            <s-form @submit="addEditItem">
                <div class="row">
                    <div class="col-lg-12">
                        <validated-input label="Name" :rules="{required: true}"
                                         class="" border-radius="1" v-model="editingItem.name "></validated-input>
                    </div>
                    <div class="col-lg-12">
                        <validated-ajax-vue-select :url="topicSelectUrl" label="Topic" v-model="editingItem.topic"></validated-ajax-vue-select>
                    </div>
                    <div class="col-lg-12">
                        <validated-text-area label="Custom Prompt"
                                         class="" border-radius="1" v-model="editingItem.custom_prompt "></validated-text-area>
                    </div>
                    <div class="col-12 text-right mt-4">
                        <btn text="Save" :loading="editLoading" loading-text="Saving..." class="px-4"></btn>
                    </div>
                </div>
            </s-form>
        </modal>

        <delete-modal ref="deleteModal" enter-animation="animated slideInDown" exit-animation="animated slideOutUp" :url="deleteURL" :params="{id : itemID}"
                      @response="deleteComplete">
            <p> Are you sure ?</p>
            <template #loading>
                <div class="fl-x">
                    <loading-animation/>
                    <b class="ml-3">Please Wait...</b>
                </div>
            </template>
        </delete-modal>

    </div>

</template>

<script>
import axios from 'secure-axios';
import urls from '../../../data/urls';

export default {
    name: 'InterviewTopic',
    data () {
        return {
            topicSelectUrl: urls.mcq_interview.interview_topic.select,
            addEditURL: urls.mcq_interview.interview_sub_topic.addEdit,
            listURL: urls.mcq_interview.interview_sub_topic.list,
            deleteURL: urls.mcq_interview.interview_sub_topic.delete,
            // subTopicList: [],
            itemID: null,
            addLoading: false,
            editLoading: false,
            editStatus: false,
            editingItem: {
                id: null,
                name: null,
                topic: null,
                custom_prompt: null
            },
            model: {
                name: null,
                topic: null,
                custom_prompt: null
            },
            fields: [
                {
                    name: 'topic_name',
                    title: 'Topic'
                },
                {
                    name: 'name',
                    sortField: 'name',
                    title: 'Sub Topic'
                },

                {
                    name: '__slot:actions',
                    title: 'Actions'
                }
            ]
        };
    },
    methods: {
        async addEditItem () {
            try {
                if (this.editStatus) {
                    this.editLoading = true;
                } else {
                    this.addLoading = true;
                }
                const response = await axios.form(this.addEditURL, this.editStatus ? this.editingItem : this.model);
                const result = response.data;
                if (result.success) {
                    if (this.editStatus) {
                        this.$notify(' Interview Sub Topic Edited Successfully', 'Success', { type: 'success' });
                        this.editLoading = false;
                        this.editFormSuccess();
                    } else {
                        this.$notify('Interview Sub Topic Added Successfully', 'Success', { type: 'success' });
                        this.addLoading = false;
                        this.addFormSuccess();
                    }
                } else {
                    const errors = response.data.errors;

                    for (const key in errors) {
                        if (Object.prototype.hasOwnProperty.call(errors, key)) {
                            let errorMessage = '';
                            if (key === '__all__') {
                                errorMessage = `${errors[key]}`;
                            } else {
                                errorMessage = `${key}:  ${errors[key]}`;
                            }
                            this.$notify(errorMessage, 'Warning', { type: 'warning' });
                        }
                    }
                    this.editLoading = false;
                    this.addLoading = false;
                }
            } catch (error) {
                this.$notify(
                    'Something Went Wrong..!!',
                    error.response.status + ' ' + error.response.statusText,
                    { type: 'danger' }
                );
                this.editLoading = false;
                this.addLoading = false;
            }
        },
        addFormSuccess () {
            this.$refs.addInterviewSubTopic.close();
            this.model.name = null;
            this.model.topic = null;
            this.model.custom_prompt = null;
            this.$refs.table.refreshTable();
        },
        editFormSuccess () {
            this.editStatus = false;
            this.$refs.editInterviewSubTopic.close();
            this.$refs.table.refreshTable();
        },
        editItem (item) {
            console.log('edit-item:>>>:', item);
            this.editStatus = true;
            this.editingItem.id = item.id;
            this.editingItem.name = item.name;
            this.editingItem.topic = item.topic;
            this.editingItem.custom_prompt = item.custom_prompt;
            this.$refs.editInterviewSubTopic.show();
        },
        deleteItem (item) {
            this.itemID = item;
            this.$refs.deleteModal.show();
        },
        deleteComplete () {
            this.$refs.table.refreshTable();
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.deleteModal.close();
        },
        addClose () {
            this.model.name = '';
            this.$refs.addInterviewSubTopic.close();
        }
    }
};
</script>

<style scoped>

</style>
